export default __webpack_public_path__ + "static/media/JONY-BELTRAN.fc467786.png";